import { useMemo } from 'react';

import {
  ALL_STYLES,
  CreatedFrom,
  GeneratedImageStatus,
} from 'src/modules/homeownerApp/static_values';

import type { AiOrSampleDisplayImage } from '../types';
import { isAiDisplay } from '../types';

const filterDisplayImages = (
  style: string,
  displayImages: AiOrSampleDisplayImage[],
) => {
  if (style === ALL_STYLES) {
    return displayImages.filter(
      image => image.aiGeneratedImage.status !== GeneratedImageStatus.FAILED,
    );
  }

  return displayImages.filter(
    displayImage =>
      (displayImage.createdFrom === CreatedFrom.ORIGINAL ||
        displayImage.style?.toLowerCase() === style.toLowerCase()) &&
      displayImage.aiGeneratedImage.status !== GeneratedImageStatus.FAILED,
  );
};

export function randomizeArray<T>(arr: T[]): T[] {
  const shuffledArray = [...arr];
  for (let i = shuffledArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
}

const sortDisplayImages = (
  a: AiOrSampleDisplayImage,
  b: AiOrSampleDisplayImage,
) => {
  if (
    a.createdFrom === CreatedFrom.ORIGINAL &&
    b.createdFrom !== CreatedFrom.ORIGINAL
  ) {
    return -1;
  }

  if (
    b.createdFrom === CreatedFrom.ORIGINAL &&
    a.createdFrom !== CreatedFrom.ORIGINAL
  ) {
    return 1;
  }

  if (!isAiDisplay(a) || !isAiDisplay(b)) {
    return 0;
  }

  return a.id - b.id;
};

export const useFilterDisplayImagesByStyle = (
  style: string,
  displayImages: AiOrSampleDisplayImage[],
  shuffle: boolean = false,
) =>
  useMemo(() => {
    const filtered = filterDisplayImages(style, displayImages);

    return (shuffle ? randomizeArray(filtered) : filtered).sort(
      sortDisplayImages,
    );
  }, [style, displayImages, shuffle]);
